import { Nullable } from "../Controls/Internals/ControlsReexport/CustomControls/ReactUIUtilituTypes";

export enum FormSettingsActionType {
    SetPortalUserId = "FormSettings.SetPortalUserId",
}

export interface FormSettingsAction {
    type: FormSettingsActionType.SetPortalUserId;
    payload: {
        value: Nullable<string>;
    };
}
